export const translations = {
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      services: 'Leistungen',
      gallery: 'Galerie',
      videos: 'Videos',
      contact: 'Kontakt',
    },
    
    // Hero Section
    hero: {
      badge: 'Authentische Bayerische Musik aus München',
      subtitle: 'Live-Musik für jeden Anlass',
      description: 'Traditionelle bayerische Melodien, Rockklassiker und alles dazwischen. Auftritte auf dem Oktoberfest in München sowie bei Hochzeiten, Geburtstagen und allen Feiern.',
      bookEvent: 'Event buchen',
      viewGallery: 'Galerie ansehen',
      features: {
        weddings: {
          title: 'Hochzeiten & Feiern',
          desc: 'Ihren besonderen Tag unvergesslich machen',
        },
        traditional: {
          title: 'Traditionell & Modern',
          desc: 'Von bayerischen Klassikern bis zu Rock-Favoriten',
        },
        venues: {
          title: 'Drinnen & Draußen',
          desc: 'Perfekt für jeden Veranstaltungsort',
        },
      },
    },
    
    // About Section
    about: {
      badge: 'Über Manfred',
      title: 'Leidenschaft für Musik',
      titleHighlight: 'Seit einem Leben',
      intro: 'Manfred Hahnel, bekannt als Quetschnmanfred, ist ein Vollblutmusiker mit einer lebenslangen Leidenschaft für bayerische Musik. Geboren und aufgewachsen im Raum München, bringt er authentische bayerische Tradition mit moderner Energie zusammen.',
      paragraph1: 'Mit jahrzehntelanger Erfahrung und grenzenloser Begeisterung ist Manfred der perfekte Musiker für jede Veranstaltung. Seine hochenergetischen Auftritte bringen Menschen jeden Alters zum Tanzen, Lachen und Mitsingen.',
      paragraph2: 'Ob traditionelle bayerische Volksmusik, Rock-Klassiker oder moderne Hits – Manfred beherrscht sie alle. Seine Vielseitigkeit und sein Gespür für das Publikum machen jede Veranstaltung zu einem unvergesslichen Erlebnis.',
      highlight: 'Von Hochzeiten über Geburtstage bis zum Oktoberfest in München – Manfred bringt die perfekte Mischung aus Tradition und Moderne zu Ihrer Feier.',
    },
    
    // Services Section
    services: {
      badge: 'Unsere Leistungen',
      title: 'Perfekte Musik für',
      titleHighlight: 'Jeden Anlass',
      description: 'Ob kleine Runde oder große Feier, wir bringen die richtige Musik und Energie, um Ihre Veranstaltung zu etwas Besonderem zu machen.',
      items: {
        weddings: {
          title: 'Hochzeiten',
          description: 'Schaffen Sie magische Momente an Ihrem besonderen Tag mit romantischen Melodien und fröhlichen Feiern.',
          features: ['Zeremoniemusik', 'Cocktailstunde', 'Hochzeitstanz'],
        },
        birthdays: {
          title: 'Geburtstagsfeiern',
          description: 'Machen Sie Geburtstage unvergesslich mit Musik, die alle zusammenbringt.',
          features: ['Alle Altersgruppen', 'Individuelle Playlists', 'Interaktiver Spaß'],
        },
        celebrations: {
          title: 'Feiern',
          description: 'Von Jubiläen bis Abschlussfeiern liefern wir den perfekten Soundtrack für jeden Meilenstein.',
          features: ['Jubiläen', 'Abschlussfeiern', 'Treffen'],
        },
        oktoberfest: {
          title: 'Oktoberfest München',
          description: 'Authentische bayerische Oktoberfest-Musik vom originalen Oktoberfest in München. Echte Festivalatmosphäre für Ihre Veranstaltung.',
          features: ['Traditionelle Lieder', 'Biergarten-Stimmung', 'Original München'],
        },
        indoor: {
          title: 'Indoor-Veranstaltungen',
          description: 'Professionelle Indoor-Auftritte mit hervorragender Akustik und gemütlicher Atmosphäre.',
          features: ['Tontechnik', 'Lichtoptionen', 'Flexible Setups'],
        },
        outdoor: {
          title: 'Outdoor-Veranstaltungen',
          description: 'Open-Air-Auftritte bei Skigebieten, Berghütten und Outdoor-Feiern. Authentische bayerische Musik in der Natur.',
          features: ['Skigebiete', 'Berghütten', 'Outdoor-Feiern'],
        },
      },
      note: 'Sie finden nicht, was Sie suchen?',
      noteHighlight: 'Wir erstellen individuelle Erlebnisse für jeden Veranstaltungstyp!',
    },
    
    // Gallery Section
    gallery: {
      badge: 'Fotogalerie',
      title: 'Momente, die wir',
      titleHighlight: 'Gemeinsam geschaffen haben',
      description: 'Werfen Sie einen Blick auf einige unserer Lieblingsauftritte und die Freude, die wir zu zahllosen Feiern gebracht haben.',
      categories: {
        performance: 'Live-Auftritt',
        stage: 'Bühnenauftritt',
        festival: 'Festival',
        traditional: 'Traditionell',
        wedding: 'Hochzeit',
        solo: 'Solo-Auftritt',
        setup: 'Bühnenaufbau',
        portrait: 'Porträt',
        duo: 'Duo',
      },
    },
    
    // Video Section
    videos: {
      badge: 'Videogalerie',
      title: 'Erleben Sie unsere',
      titleHighlight: 'Live-Auftritte',
      description: 'Sehen Sie Highlights unserer Auftritte und spüren Sie die Energie, die wir zu jeder Veranstaltung mitbringen.',
      note: 'Möchten Sie mehr von unseren Auftritten sehen?',
      noteHighlight: 'Folgen Sie uns in den sozialen Medien für die neuesten Videos und Updates!',
    },
    
    // Contact Section
    contact: {
      badge: 'Kontakt aufnehmen',
      title: 'Machen wir Ihre Veranstaltung',
      titleHighlight: 'Unvergesslich',
      description: 'Bereit, uns für Ihre nächste Feier zu buchen? Füllen Sie das Formular aus und wir melden uns mit einem persönlichen Angebot.',
      info: 'Kontaktinformationen',
      form: {
        name: 'Vollständiger Name',
        email: 'E-Mail-Adresse',
        phone: 'Telefonnummer',
        eventType: 'Veranstaltungsart',
        eventDate: 'Veranstaltungsdatum',
        guests: 'Anzahl der Gäste',
        message: 'Nachricht',
        eventTypes: {
          wedding: 'Hochzeit',
          birthday: 'Geburtstagsfeier',
          oktoberfest: 'Oktoberfest',
          corporate: 'Firmenveranstaltung',
          festival: 'Festival',
          other: 'Sonstiges',
        },
        privacy: 'Ich habe die',
        privacyLink: 'Datenschutzerklärung',
        privacyText: 'zur Kenntnis genommen. Ich stimme zu, dass meine Angaben zur Kontaktaufnahme und für Rückfragen gespeichert werden.',
        submit: 'Nachricht senden',
        sent: 'Nachricht gesendet!',
        placeholder: 'Erzählen Sie uns mehr über Ihre Veranstaltung, den Veranstaltungsort, spezielle Wünsche, usw.',
      },
      whatsapp: 'WhatsApp',
      email: 'E-Mail',
    },
    
    // Footer
    footer: {
      tagline: 'Authentische bayerische Musik und unvergessliche Auftritte für Ihre besonderen Veranstaltungen seit 2009.',
      quickLinks: 'Schnelllinks',
      ourServices: 'Unsere Leistungen',
      contactUs: 'Kontakt',
      services: [
        'Hochzeiten',
        'Geburtstagsfeiern',
        'Oktoberfest',
        'Firmenveranstaltungen',
        'Outdoor-Festivals',
        'Indoor-Veranstaltungen',
      ],
      rights: 'Alle Rechte vorbehalten.',
      vibed: 'Erstellt mit',
    },
  },
  
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      gallery: 'Gallery',
      videos: 'Videos',
      contact: 'Contact',
    },
    
    // Hero Section
    hero: {
      badge: 'Authentic Bavarian Music from Munich',
      subtitle: 'Live Music for Every Occasion',
      description: 'Traditional Bavarian melodies, rock classics, and everything in between. Performing at Oktoberfest in Munich, as well as weddings, birthdays, and all celebrations.',
      bookEvent: 'Book Your Event',
      viewGallery: 'View Gallery',
      features: {
        weddings: {
          title: 'Weddings & Celebrations',
          desc: 'Making your special day unforgettable',
        },
        traditional: {
          title: 'Traditional & Modern',
          desc: 'From Bavarian classics to rock favorites',
        },
        venues: {
          title: 'Indoor & Outdoor',
          desc: 'Perfect for any venue or setting',
        },
      },
    },
    
    // About Section
    about: {
      badge: 'About Manfred',
      title: 'A Lifetime of',
      titleHighlight: 'Musical Passion',
      intro: 'Manfred Hahnel, known as Quetschnmanfred, is a dedicated musician with a lifelong passion for Bavarian music. Born and raised in the Munich area, he brings together authentic Bavarian tradition with modern energy.',
      paragraph1: 'With decades of experience and boundless enthusiasm, Manfred is the perfect musician for any event. His high-energy performances get people of all ages dancing, laughing, and singing along.',
      paragraph2: 'Whether it\'s traditional Bavarian folk music, rock classics, or modern hits – Manfred masters them all. His versatility and intuition for reading the audience make every event an unforgettable experience.',
      highlight: 'From weddings and birthdays to Oktoberfest in Munich – Manfred brings the perfect blend of tradition and modernity to your celebration.',
    },
    
    // Services Section
    services: {
      badge: 'Our Services',
      title: 'Perfect Music for',
      titleHighlight: 'Every Occasion',
      description: 'Whether it\'s a small gathering or a grand celebration, we bring the right music and energy to make your event truly special.',
      items: {
        weddings: {
          title: 'Weddings',
          description: 'Create magical moments on your special day with romantic melodies and joyful celebrations.',
          features: ['Ceremony Music', 'Cocktail Hour', 'Reception Dancing'],
        },
        birthdays: {
          title: 'Birthday Parties',
          description: 'Make birthdays unforgettable with music that brings everyone together in celebration.',
          features: ['All Ages Welcome', 'Custom Playlists', 'Interactive Fun'],
        },
        celebrations: {
          title: 'Celebrations',
          description: 'From anniversaries to graduations, we provide the perfect soundtrack for every milestone.',
          features: ['Anniversaries', 'Graduations', 'Reunions'],
        },
        oktoberfest: {
          title: 'Oktoberfest Munich',
          description: 'Authentic Bavarian Oktoberfest music from the original Oktoberfest in Munich. Real festival atmosphere for your event.',
          features: ['Traditional Songs', 'Beer Garden Vibes', 'Original Munich'],
        },
        indoor: {
          title: 'Indoor Events',
          description: 'Professional indoor performances with excellent acoustics and cozy atmosphere.',
          features: ['Sound Systems', 'Lighting Options', 'Flexible Setups'],
        },
        outdoor: {
          title: 'Outdoor Events',
          description: 'Open-air performances at ski resorts, mountain lodges, and outdoor celebrations. Authentic Bavarian music in nature.',
          features: ['Ski Resorts', 'Mountain Lodges', 'Outdoor Parties'],
        },
      },
      note: 'Can\'t find what you\'re looking for?',
      noteHighlight: 'We create custom experiences for any type of event!',
    },
    
    // Gallery Section
    gallery: {
      badge: 'Photo Gallery',
      title: 'Moments We\'ve',
      titleHighlight: 'Created Together',
      description: 'Take a look at some of our favorite performances and the joy we\'ve brought to countless celebrations.',
      categories: {
        performance: 'Live Performance',
        stage: 'Stage Performance',
        festival: 'Festival',
        traditional: 'Traditional',
        wedding: 'Wedding',
        solo: 'Solo Performance',
        setup: 'Stage Setup',
        portrait: 'Portrait',
        duo: 'Duo',
      },
    },
    
    // Video Section
    videos: {
      badge: 'Video Gallery',
      title: 'Experience Our',
      titleHighlight: 'Live Performances',
      description: 'Watch highlights from our performances and feel the energy we bring to every event.',
      note: 'Want to see more of our performances?',
      noteHighlight: 'Follow us on social media for the latest videos and updates!',
    },
    
    // Contact Section
    contact: {
      badge: 'Get In Touch',
      title: 'Let\'s Make Your Event',
      titleHighlight: 'Unforgettable',
      description: 'Ready to book us for your next celebration? Fill out the form below and we\'ll get back to you with a personalized quote.',
      info: 'Contact Information',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        eventType: 'Event Type',
        eventDate: 'Event Date',
        guests: 'Number of Guests',
        message: 'Message',
        eventTypes: {
          wedding: 'Wedding',
          birthday: 'Birthday Party',
          oktoberfest: 'Oktoberfest',
          corporate: 'Corporate Event',
          festival: 'Festival',
          other: 'Other',
        },
        privacy: 'I have read the',
        privacyLink: 'Privacy Policy',
        privacyText: '. I agree that my information will be stored for contact and follow-up questions.',
        submit: 'Send Message',
        sent: 'Message Sent!',
        placeholder: 'Tell us more about your event, venue, special requests, etc.',
      },
      whatsapp: 'WhatsApp',
      email: 'Email',
    },
    
    // Footer
    footer: {
      tagline: 'Bringing authentic Bavarian music and unforgettable performances to your special events since 2009.',
      quickLinks: 'Quick Links',
      ourServices: 'Our Services',
      contactUs: 'Contact Us',
      services: [
        'Weddings',
        'Birthday Parties',
        'Oktoberfest',
        'Corporate Events',
        'Outdoor Festivals',
        'Indoor Events',
      ],
      rights: 'All rights reserved.',
      vibed: 'Vibed with',
    },
  },
};

export type Language = 'de' | 'en';
